/* global Shopify */

document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.gift-card-balance-check--form');
  if (!container) return;

  const form = container.querySelector('#gift-card-balance-form');
  const codeInput = container.querySelector('#gift-card-code');
  const pinInput = container.querySelector('#gift-card-pin');
  const submitBtn = container.querySelector('#gift-card-balance-submit');
  const resultDiv = container.querySelector('#gift-card-balance-result');
  const apiEndpoint = container.getAttribute('data-api-endpoint');

  function getShopifyDomainPrefix() {
    let domain = '';
    if (window.Shopify && Shopify.shop) domain = Shopify.shop;
    else if (window.Shopify && Shopify.domain) domain = Shopify.domain;
    const prefix = domain.replace(/\.myshopify\.com$/, '');
    if (prefix === 'citta-dev') {
      return 'citta-nz-b2c';
    }
    return prefix;
  }

  function validate() {
    submitBtn.disabled = !(codeInput.value && pinInput.value);
  }

  function clearResultClasses() {
    resultDiv.classList.remove(
      'gift-card-balance-result--success',
      'gift-card-balance-result--error',
    );
    resultDiv.innerHTML = '';
  }

  codeInput.addEventListener('input', validate);
  pinInput.addEventListener('input', validate);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    submitBtn.disabled = true;
    clearResultClasses();
    fetch(apiEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        gift_card_code: codeInput.value,
        pin: pinInput.value,
        shopify_domain: getShopifyDomainPrefix(),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        clearResultClasses();
        if (data.balance) {
          const currency = data.currency ? ` ${data.currency}` : '';
          resultDiv.classList.add('gift-card-balance-result--success');
          resultDiv.textContent = `Balance: ${data.balance}${currency}`;
        } else if (data.message) {
          resultDiv.classList.add('gift-card-balance-result--error');
          resultDiv.innerHTML = `<span class="gift-card-balance-result__icon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#fff"/><path d="M12 7v5m0 4h.01" stroke="#e53935" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="11" stroke="#e53935" stroke-width="2" fill="none"/></svg></span>${data.message}`;
        } else if (data.error) {
          resultDiv.classList.add('gift-card-balance-result--error');
          resultDiv.innerHTML = `<span class="gift-card-balance-result__icon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#fff"/><path d="M12 7v5m0 4h.01" stroke="#e53935" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="11" stroke="#e53935" stroke-width="2" fill="none"/></svg></span>${data.error}`;
        } else {
          resultDiv.classList.add('gift-card-balance-result--error');
          resultDiv.textContent = 'Unknown response.';
        }
      })
      .catch(() => {
        clearResultClasses();
        resultDiv.classList.add('gift-card-balance-result--error');
        resultDiv.innerHTML = `<span class="gift-card-balance-result__icon" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#fff"/><path d="M12 7v5m0 4h.01" stroke="#e53935" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="11" stroke="#e53935" stroke-width="2" fill="none"/></svg></span>Failed to check balance.`;
      })
      .finally(() => {
        validate();
      });
  });
});
